export function CodeContentViewer({ contentData }: { contentData?: string }) {
  return (
    <div className="h-full w-full p-4">
      <pre className="bg-gray-100 p-4 rounded overflow-auto">
        <code className="text-sm">{contentData as string}</code>
      </pre>
    </div>
  )
}
